import { Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { AttachmentsDialogService, DocumentService } from "@tylertech/attachments-module";
import { AttachmentViewModel, DocumentSearchCriteria, GetNoteObjectViewModel, IMassUpdateCriteria, ITcmModel, Tuple } from "@tylertech/tyler-api-types";
import { lastValueFrom } from "rxjs";
import { DocTypeDialogComponent, DocTypeDialogData, MassUpdateDialogComponent, MassUpdateDialogData } from "./dialogs";

/**
 * TODO - Why are these hard-coded here?
 */
export const SchoolsEntity = {
    PayrollEmployee: "IV.PayrollEmployee",
    AccountsPayableVendor: "IV.AccountsPayableVendor",
} as const;

const entitiesWithDocTypes: ReadonlyArray<string> = [
    SchoolsEntity.PayrollEmployee,
    SchoolsEntity.AccountsPayableVendor,
];

export interface AddAttachmentOptions
{
    // readonly useDocTypes: boolean;
    readonly entity: GetNoteObjectViewModel;
    readonly attachments: Array<AttachmentViewModel>;
    readonly tcmModel?: ITcmModel;
    readonly disabled?: boolean;
    readonly hasTCM?: boolean;
}

@Injectable()
export class AdvancedComponentsDialogService
{
    constructor(
        private readonly matDialog: MatDialog,
        private readonly $documentApiService: DocumentService,
        private readonly $attachmentsDialogService: AttachmentsDialogService,)
    { }

    showMassUpdate(config: MassUpdateDialogData): Promise<IMassUpdateCriteria | boolean>
    {
        const dialogConfig: MatDialogConfig<MassUpdateDialogData> = {
            data: config,
            width: "100vw"
        };

        const dialogRef = this.matDialog.open(MassUpdateDialogComponent, dialogConfig);
        return lastValueFrom(dialogRef.afterClosed());
    }

    showDocTypeDialog(entity: GetNoteObjectViewModel): Promise<Tuple<string, string> | undefined>
    {
        const criteria: DocumentSearchCriteria = {
            EntityId: entity.Id,
            EntityType: entity.Type,
        };
        return this.$documentApiService.GetDocTypes(criteria)
            .then(result =>
            {
                const dialogConfig: MatDialogConfig<DocTypeDialogData> = {
                    data: {
                        docTypes: result.Result
                    }
                };
                const dialogRef = this.matDialog.open(DocTypeDialogComponent, dialogConfig);
                return lastValueFrom(dialogRef.afterClosed());
            });
    }

    showAddAttachment({ entity, tcmModel, attachments, disabled, hasTCM }: AddAttachmentOptions): Promise<Array<AttachmentViewModel>>
    {
        if (entitiesWithDocTypes.includes(entity.Type))
        {
            return this.showDocTypeDialog(entity)
                .then((choice: Tuple<string, string>) =>
                {
                    const selectedType = !hasTCM || choice.Item2 !== "View All"
                        ? choice.Item2
                        : undefined;
                    return this.$attachmentsDialogService.show(
                        entity.Id,
                        entity.Type,
                        true,
                        tcmModel,
                        attachments,
                        disabled,
                        selectedType);
                });
        }

        return this.$attachmentsDialogService.show(
            entity.Id,
            entity.Type,
            true,
            tcmModel,
            attachments,
            disabled);
    }
}
